export enum DiaryFormElementType {
  SingleLineText = 0,
  MultiLineText = 1,
  Checkbox = 2,
  Radio = 3,
  Dropdown = 4,
  Date = 5,
  Numeric = 6,
  Time = 7
}
